"use client";

import { cn } from "@/lib/utils";
import { useState } from "react";
import Image from "next/image";
import posthog from "posthog-js";

export default function ThreeTabsSection({
  tabOneTitle,
  tabOneContent,
  tabOneImage,
  tabTwoTitle,
  tabTwoContent,
  tabTwoImage,
  tabThreeTitle,
  tabThreeContent,
  tabThreeImage,
  sectionClassName,
  containerClassname,
  tabClassName,
  activeTabClassName,
}: {
  tabOneTitle: string;
  tabOneContent: React.ReactNode;
  tabOneImage?: string;
  tabTwoTitle: string;
  tabTwoContent: React.ReactNode;
  tabTwoImage?: string;
  tabThreeTitle: string;
  tabThreeContent: React.ReactNode;
  tabThreeImage?: string;
  sectionClassName?: string;
  activeTabClassName?: string;
  tabClassName?: string;
  containerClassname?: string;
}) {
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <section
      className={cn(
        "my-20 flex w-full flex-col items-stretch justify-center px-6 md:my-30 lg:my-40",
        sectionClassName,
      )}
    >
      <div className="mx-auto w-full max-w-[1200px] overflow-hidden rounded-xl transition-all duration-300">
        <div className="divide-primary flex items-end divide-x md:flex-row">
          <div
            className={cn(
              "base-tab rounded-tl-xl border-t border-l",
              selectedTab === 0
                ? cn("active-tab", activeTabClassName)
                : cn("inactive-tab", tabClassName),
            )}
            onClick={() => {
              setSelectedTab(0);
              posthog.capture("tab_selected", { tab_title: tabOneTitle });
            }}
          >
            {tabOneTitle}
          </div>
          <div
            className={cn(
              "base-tab border-t",
              selectedTab === 1
                ? cn("active-tab", activeTabClassName)
                : cn("inactive-tab", tabClassName),
            )}
            onClick={() => {
              setSelectedTab(1);
              posthog.capture("tab_selected", { tab_title: tabTwoTitle });
            }}
          >
            {tabTwoTitle}
          </div>
          <div
            className={cn(
              "base-tab rounded-tr-xl border-t border-r",
              selectedTab === 2
                ? cn("active-tab", activeTabClassName)
                : cn("inactive-tab", tabClassName),
            )}
            onClick={() => {
              setSelectedTab(2);
              posthog.capture("tab_selected", { tab_title: tabThreeTitle });
            }}
          >
            {tabThreeTitle}
          </div>
        </div>
        <div className="border-primary relative rounded-b-xl border">
          <div
            className={cn(
              "p relative z-10 px-6 py-4 md:rounded-tl-xl md:rounded-tr-none",
              containerClassname,
            )}
          >
            {selectedTab == 0 && tabOneContent}
            {selectedTab == 1 && tabTwoContent}
            {selectedTab == 2 && tabThreeContent}
          </div>
          <div className="filter-primary absolute right-4 bottom-4 flex size-32 items-end justify-center opacity-20 lg:right-16 lg:size-40">
            {tabOneImage && (
              <Image
                src={tabOneImage as string}
                alt="tab icon"
                width={240}
                height={240}
                className={cn("object-center", {
                  hidden: selectedTab !== 0,
                })}
              />
            )}
            {tabTwoImage && (
              <Image
                src={tabTwoImage as string}
                alt="tab icon"
                width={240}
                height={240}
                className={cn("object-center", {
                  hidden: selectedTab !== 1,
                })}
              />
            )}
            {tabThreeImage && (
              <Image
                src={tabThreeImage as string}
                alt="tab icon"
                width={240}
                height={240}
                className={cn("object-center", {
                  hidden: selectedTab !== 2,
                })}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
